import type { RouteRecordRaw, RouteComponent } from 'vue-router'
import type { RouteMiddleware } from '#app'
import { PageTypes } from '@core/constants/pages'

export function getIMTLiveRoutes(
  component: RouteComponent,
  middleware?: RouteMiddleware,
): RouteRecordRaw[] {
  return [
    {
      name: 'imt-live',
      path: `/${LANG_PARAM}/compare/transfer/:countryFrom/:countryTo/:currencyFrom/:currencyTo/:amount?`,
      meta: { pageType: PageTypes.TRANSFER, middleware },
      component,
    },
  ]
}
